<ng-select [items]="items"
           bindValue="code"
           [placeholder]="'send-category-search.search' | transloco"
           [typeToSearchText]="'spend-category-search.placeholder.search' | transloco"
           [notFoundText]="'spend-category-search.noFind' | transloco"
           [loadingText]="'spend-category-search.loader' | transloco"
           [multiple]="false"
           [hideSelected]="true"
           [trackByFn]="trackByFn"
           [loading]="itemLoading"
           [typeahead]="itemInput$"
           (change)="onCategoryChanged($event)"
           [(ngModel)]="selected"
           [disabled]="disabled">
  <ng-template ng-label-tmp let-item="item">
    {{item.title | uiLabel}}
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    {{item.title | uiLabel}}
  </ng-template>
</ng-select>
